import script from "./NestVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./NestVideo.vue?vue&type=script&setup=true&lang=js"

import "./NestVideo.vue?vue&type=style&index=0&id=3643a7b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3643a7b8"]])

export default __exports__